<script setup>
const props = defineProps({ 
  isLargeScreen : Boolean
})
</script>

<template>
  <div style="min-height: 270px; display: inline-flex; justify-content: center; align-items: center;">
    <div style="width: 300px; height: 250px; margin: 10px; padding: 0; background: rgba(0,0,0,.2);">
      <div id="9d18e23f3ab19ce2c2e20e384c38a711" ></div>
    </div>
    <div v-if="props.isLargeScreen" style="width: 300px; height: 250px; margin: 10px; padding: 0; background: rgba(0,0,0,.2);">
      <!-- 640px以上の画面でのみ表示 -->
      <div id="c29bb538542ee331a766f8263bbcdf1d" ></div>
    </div>
  </div>
</template>

<style scoped>
</style>